import { AUTH_REALM } from "@/constants";
import { performApiRequest } from "@/shared/api/performApiRequest";
import { assertAdminAuthRealm, resolveAuthRealm } from "@/shared/auth/authRealm";

/**
 * Olive staff / admin platform API client.
 * Does not send a `tenant` header. Uses admin-realm Cognito tokens only.
 */
export async function adminApiFetch(
  path: string,
  init: RequestInit = {},
): Promise<Response> {
  const realm = resolveAuthRealm();
  assertAdminAuthRealm(realm);

  return performApiRequest(path, init, {
    authRealm: AUTH_REALM.ADMIN,
  });
}
